<template>
  <div :class="['dataType', direction]">
    <div class="dataType__name">Type:</div>
    <div class="dataType__radiowrap">
      <div
        :class="['dataType__radiowrap__el', { checked: dataType === dt }]"
        :key="index"
        v-for="(dt, index) in dataTypes"
      >
        <div class="dataType__radiowrap--radio" @click="dataTypeClick(dt)">
          <input
            class="dataType__radiowrap--radio--input"
            type="radio"
            :id="dt"
            name="radio-dataType"
            :value="dt"
            :checked="dataType === dt"
          />
          <div class="dataType__radiowrap--radio--outer"></div>
          <div class="dataType__radiowrap--radio--inner"></div>
        </div>
        <label :class="['dataType__radiowrap--label']" :for="dt">{{
          changeLabel(dt.toUpperCase())
        }}</label>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "FilterDataType",
  props: {
    direction: {
      type: String,
      default: "row",
    },
  },
  computed: {
    dataTypes() {
      // condition to check if a source has special dataTypes
      if (
        this.sourceConfig.sources &&
        this.sourceConfig.sources.find((el) => el.key === this.source) &&
        this.sourceConfig.sources.find((el) => el.key === this.source).dataTypes
      ) {
        // call function to make new dataType selected
        this.dataTypeClick(
          this.sourceConfig.sources.find((el) => el.key === this.source)
            .dataTypes[0]
        );
        return this.sourceConfig.sources.find((el) => el.key === this.source)
          .dataTypes;
      }
      return this.sourceConfig.dataTypes;
    },
    ...mapGetters({
      dataType: "ui/dataType",
      source: "ui/source",
      sourceConfig: "ui/currentSourceConfig",
    }),
  },

  methods: {
    dataTypeClick(key) {
      this.setDataType(key);
      this.calcData();
    },
    changeLabel(oldLabel) {
      // patch to change wind labels
      const map = this.sourceConfig.dataTypesMap;
      if (!map) return oldLabel;

      return map.find((o) => o.key.toUpperCase() === oldLabel.toUpperCase())
        .label;
    },
    ...mapActions({
      setDataType: "ui/setDataType",
      calcData: "data/calcData",
    }),
  },
};
</script>

<style lang="scss" scoped>
.dataType {
  display: flex;
  height: 100%;
  min-width: fit-content;
  color: $ui-white;

  &__name {
    @include p-s;
    display: flex;
    margin-right: toRem(10);

    .column & {
      margin-bottom: toRem(15);
    }

    .row & {
      justify-content: center;
      align-items: center;
    }
  }
  &__radiowrap {
    display: flex;

    .column & {
      flex-direction: column;
      align-items: flex-start;
    }

    .row & {
      flex-direction: row;
      align-items: center;
    }

    &__el {
      display: flex;
      align-items: center;
      &:hover {
        .dataType__radiowrap--label {
          color: $white_08;
        }
      }
      &.checked {
        .dataType__radiowrap--label {
          color: var(--primary-yellow);
        }
      }
    }

    &--radio {
      position: relative;
      width: toRem(12);
      height: toRem(12);
      cursor: pointer;

      &--outer {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: rgba(255, 255, 255, 0.2);
        border-radius: 50%;
        border: $white-border;
        border-color: #fff;
        width: 100%;
        height: 100%;
      }

      &--inner {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: $primary-yellow;
        border-radius: 50%;
        width: toRem(6.89);
        height: toRem(6.89);
        display: none;
      }

      &--input {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        margin: 0;
        visibility: hidden;

        &:checked ~ .dataType__radiowrap--radio--outer {
          border-color: $primary-yellow;
        }

        &:checked ~ .dataType__radiowrap--radio--inner {
          display: block;
        }
      }

      &:checked + label {
        color: $primary-yellow;
      }
      &:not(:checked) + label {
        color: $white_04;
      }
    }

    &--label {
      display: block;
      margin-top: toRem(1);
      @include link-s;
      text-transform: uppercase;
      cursor: pointer;
      padding-left: toRem(5);
      .row & {
        margin-right: toRem(15);
      }
    }
  }
}

.mobile {
  .dataType {
    flex-direction: column;
    &.row {
      justify-content: flex-start;
      align-items: flex-start;
    }

    &__name {
      margin-bottom: toRem(15);
    }
  }
}

.tablet {
  .dataType {
    flex-direction: column;
    &.row {
      justify-content: flex-start;
      align-items: flex-start;
    }

    &__name {
      margin-bottom: toRem(15);
    }
  }
}
</style>
